export const ACTIONS = {
  REQUEST_PERSONTASK: 'REQUEST_PERSONTASK',
  RECEIVE_PERSONTASK: 'RECEIVE_PERSONTASK',
  RECEIVE_PERSONTASK_ERROR: 'RECEIVE_PERSONTASK_ERROR',
};

export default ACTIONS;
